Jelly.Utilities.Reload_Page = function()
{
	// Reloads page.
	
//			alert("Reload");
	// TODO: parameter forceGet = true? false (default) loads from cache.
	document.location.reload();
// 	throw 'FAKE RELOAD PAGE';
};